import { CSSObject } from '@chakra-ui/react';
import { BannerSchema } from '@/views/account/Overview/components/Banner/styles/Banner.styles';
import bg from '@/assets/bet777/images/account/bannerBg.png';
import bgMb from '@/assets/bet777/images/account/bannerBgMb.png';

export const bannerStyles: BannerSchema = {
  buttonDeposit: {
    variant: 'secondary',
    fontWeight: 'normal',
  },
};
export const FlexBannerContainer: CSSObject = {
  borderRadius: 'md',
  bgImage: [`url(${bgMb})`, null, `url(${bg})`],
  bgSize: 'cover',
  color: 'white',
  gap: '0',
  p: ['2', null, '3'],
  minH: '107px',
};
export const FlexAccountDetails: CSSObject = {
  alignItems: [null, null, 'center'],
  flexDir: ['column', null, 'row'],
  gap: '1.5',
  borderBottom: '1px dashed',
  borderBottomColor: '#1C233F',
};
export const FlexAccountName: CSSObject = {
  fontSize: 'lg',
  fontFamily: 'Staatliches',
  fontWeight: 'normal',
  color: 'beta.400',
  textTransform: 'uppercase',
};
export const FlexAccountBalances: CSSObject = {
  gap: '8',
  mt: [null, null, '0'],
  mr: [null, null, '-2'],
  px: [null, null, '4'],
  py: ['3', null, '2'],
};
export const FlexBannerBalanceInner: CSSObject = {
  flex: ['1', null, '0 1 auto'],
};
export const TextAccountBalanceLabel: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'normal',
  textTransform: 'uppercase',
  fontFamily: 'Staatliches',
  textAlign: ['start', null, 'end'],
};
export const FlexAccountBalanceWrapper: CSSObject = {
  fontSize: 'lg',
  fontFamily: 'Staatliches',
  fontWeight: 'normal',
  textTransform: 'uppercase',
  textShadow: 'none',
};
export const TextAccountBalanceCurrencySymbol = (): CSSObject => ({
  display: 'inline',
  verticalAlign: 'super',
  color: 'gamma.400',
});
export const TextAccountBalanceBaseUnit = (): CSSObject => ({
  color: 'gamma.400',
});
export const TextAccountBalanceSubUnit = (): CSSObject => ({
  color: 'gamma.400',
});
export const FlexButtonContainer: CSSObject = {
  flexDir: ['column', null, 'row'],
  gap: '2',
  borderTop: '1px dashed',
  borderTopColor: '#414C74',
  pt: '2',
};
export const TextButton: CSSObject = {
  h: '4',
  fontFamily: 'Staatliches',
  color: 'alpha.700',
  textTransform: 'capitalize',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.25)',
};
export const FlexBalanceBetInfo: CSSObject = {
  bg: 'solid',
  borderRadius: 'md',
  border: '2px',
  borderColor: 'alpha.200',
  color: ['white', null, 'gamma.400'],
  textShadow: '0px 2px 3px rgba(0, 0, 0, 0.3)',
  fontFamily: 'Staatliches',
  fontSize: 'sm',
  textTransform: 'capitalize',
  fontWeight: 'normal',
  alignItems: 'center',
  h: '10',
  justifyContent: 'center',
  flex: ['1', null, '0'],
  px: '4',
  py: '3',
  whiteSpace: [null, null, 'nowrap'],
};
export const FlexLabel: CSSObject = {
  flexDirection: ['column', null, 'row'],
};
